import { useCallback, useEffect, useRef, useState } from "react";
import { Card } from "./Card/Card";
import "./CardList.css";
import api from "../../functions/api";

export function CardList() {
  const [cards, setCards] = useState([]);
   const effectRan = useRef(false);
  const getInitialPromptsToTry = useCallback(async () => {
    try {
      const jwt = localStorage.getItem("jwt") || "";
      const prompts = await api.fetchPromptsTotry(jwt, "filter");
      setCards(prompts)
    } catch (error) {
      console.error("Prompt to try error:", error);
    }
  }, []); 


  useEffect(() => {
    if (!effectRan.current) {
      getInitialPromptsToTry();
    } 
    return () => {
      effectRan.current = true;
    }
  });

  return (
    <>
      <div className="cards-container">
        <div className="cards">
          {cards.map((card) => {
            return <Card card={card} />;
          })}
        </div>
      </div>
    </>
  );
}
